import { FaMinus } from "react-icons/fa";
import Icon from "../common/Icon";
import { FaCircleMinus } from "react-icons/fa6";

const ListingComponent = ({ item, onClick, activeItem, initialItem }) => {
  const isActive = activeItem === item._id;

  return (
    <div
      title="Click to view news details"
      className={`flex relative  items-center flex-row justify-start cursor-pointer  py-4 ps-4 pe-8   items-center justify-center  rounded-[15px] hover:text-orange hover:shadow-lg relative  mb-2 md:mb-4 lg:mb-6 ${
        isActive ? "bg-quaternary/60" : "bg-[#f0f2f0]"
      }`}
      onClick={onClick}
    >
      {/* Left Section - Date */}
      <div className="flex flex-col items-center justify-center md:text-center  md:w-20 flex-shrink-0 me-5 md:ms-2 gap-0 md:gap-0">
        {item?.date?.day && (
          <p className="date text-4xl md:text-5xl  font-bold mb-1 text-secondary">{item?.date?.day}</p>
        )}
        {item?.date?.month && (
          <p className="month text-lg leading-none uppercase text-secondary">{item?.date?.month}</p>
        )}
        {item?.date?.year && (
          <p className="year text-lg leading-none text-secondary">{item?.date?.year}</p>
        )}
      </div>

      {/* Middle Section */}
      <div className={`middleSection flex-1 md:relative p-2 rounded-md`}>
        {/* Hover overlay */}
        <div className="absolute inset-0 hover:bg-green/5 transition-colors rounded-md pointer-events-none"></div>

        {/* Plus Icon */}
        <div className="PlusIcon absolute top-2 right-2 md:-top-2 md:-right-5">
          {!isActive ? (
            <Icon
              icon="plus"
              className="hover:text-orange w-[28px] xl:w-[35px] "
            />
          ) : (
            <FaCircleMinus className="hover:text-orange text-[28px] xl:text-[35px] " />
          )}
        </div>

        {/* Content */}
        <div className="flex flex-col gap-2">
          {item.title && (
            <p className="title text-green text-28pt leading-tight">
              {item.title}
            </p>
          )}
          {item.shortDescription && (
            <p className="subtitle text-24pt leading-tight font-mono text-secondary">
              {item.shortDescription}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ListingComponent;
